<dx-select-box
  valueExpr="PortalTemplateId"
  displayExpr="Name"
  searchExpr="Name"
  [dataSource]="portalTemplates"
  [value]="selectedTemplate"
  [placeholder]="languageService.LNG('Label.Template.Use')"
  (onValueChanged)="onPortalTemplateValueChanged($event)">
</dx-select-box>
